module.exports = __webpack_public_path__ + "img/advantage6.a29791c6.png";